import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getQuiz = async () => {
  const { data } = await axios.get(`${API}/quiz`);
  return data;
};

export const submitQuiz = async (payload) => {
  const { data } = await axios.post(`${API}/quiz/submit`, payload);
  return data;
};

export const trackEvent = async (type, session_id, meta = {}) => {
  try {
    await axios.post(`${API}/events`, { type, session_id, meta });
  } catch (e) {
    // non-blocking
  }
};
